// src/components/salon-management/hooks/useCustomerSelection.ts
import { useEffect, useState } from "react";
import { CustomerDetails, PaginationState } from "../types/salon.types";
import { useUser } from "src/shared/context/UserContext";
import { getCustomer } from "src/shared/services/servicesv2";

export const useCustomerSelection = (open: boolean, initialRows: number = 10) => {
  const [customers, setCustomers] = useState<CustomerDetails[]>([]);
  const [filteredCustomers, setFilteredCustomers] = useState<CustomerDetails[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const{userConfigration}=useUser()
  const [pagination, setPagination] = useState<PaginationState>({
    currentPage: 1,
    pageSize: userConfigration?.tableDefaultSize || initialRows,
    totalPages: 1,
    totalRecords: 0,
  });

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await getCustomer(
        false,                         // include_deleted
        pagination.currentPage,        // pageNumber
        pagination.pageSize,           // pageSize
        searchTerm                     // searchBy
      );
      // api.get(
      //   `/app/v1/pos/customer?include_deleted=False&pageNumber=${pagination.currentPage}&pageSize=${pagination.pageSize}&searchBy=${searchTerm}`
      // );

      const data = response.data;
      setCustomers(data.customer_details);
      setFilteredCustomers(data.customer_details);
      setPagination(prev => ({
        ...prev,
        totalPages: Math.ceil(data.totalRecords / pagination.pageSize),
        totalRecords: data.totalRecords,
      }));
    } catch (error) {
      console.error("Error fetching customer data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchCustomers();
    } else {
      setSearchTerm("");
    }
  }, [open, pagination.currentPage, pagination.pageSize, searchTerm]);

  useEffect(() => {
    if (!searchTerm) {
      setFilteredCustomers(customers);
    } else {
      const filtered = customers.filter(c => {
        const name = c.firstName?.toLowerCase() || "";
        const phone = c.phones[0].phone.toString() || "";
        return name.includes(searchTerm.toLowerCase()) || phone.includes(searchTerm);
      });
      setFilteredCustomers(filtered);
    }
  }, [searchTerm, customers]);

  const handleNextPage = () => {
    if (pagination.currentPage < pagination.totalPages) {
      setPagination(prev => ({ ...prev, currentPage: prev.currentPage + 1 }));
    }
  };

  const handlePrevPage = () => {
    if (pagination.currentPage > 1) {
      setPagination(prev => ({ ...prev, currentPage: prev.currentPage - 1 }));
    }
  };

  return {
    customers: filteredCustomers,
    searchTerm,
    setSearchTerm,
    loading,
    pagination,
    handleNextPage,
    handlePrevPage,
  };
};
